import React from "react";
import "../styling/styles.css";

export default function Home() {
    return (
        <div>
            <div class="header-custom" id="home">
                <img src="./header.gif" class="img-fluid" alt="animated header"></img>
            </div>
        </div>
    )
}